export default "/images/72d39610a13a47336aa9c5ccd121855c.avif";